import request from '@/utils/request'
import { api } from '~/ui-domain'
import { decorType } from '@/utils/decor-types'

/**
 * 获取所有店铺
 */
export function getAllShopList() {
  return request({
    url: `${decorType}/shops/list`,
    method: 'get',
    loading: false
  })
}

/**
 * 获取店铺详情
 * @param shop_id
 * @returns {AxiosPromise<any>|Promise<unknown>|*}
 */
export function getShopDetail(shop_id) {
  return request({
    url: `${api.buyer}/shops/${shop_id}`,
    method: 'get',
    loading: false
  })
}
